<template>
	<div>
		<section class="section-title-page container-fluid" style="background-image: url('/img/bg_tramite.jpg')">
			<div class="container">
				<div class="wrapper">
					<h1>Documentos <small style="font-weight: 300"> Normativos</small></h1>
					<span>
						Volver <i class="fa fa-angle-right mx-1"></i>
						<a href="index.html">Inicio</a>
					</span>
				</div>
			</div>
		</section>
		<section class="section-page container-fluid">
			<div class="container">
				<div class="section-info">
					<p class="m-0"><i class="fa-solid fa-circle mr-2"></i>Descarga los reglamentos y normativas oficiales que regulan el ejercicio de la <strong>medicina veterinaria</strong>.</p>
				</div>
			</div>
			<div class="container section-page px-0">
				<div class="col px-1 section-pdf">
					<div class="col-md-2 pl-0 pr-2" v-for="(value, k) in Documentos" :key="k">
						<div class="box">
							<a class="float-download" v-if="value.archivo" :title="value.titulo" href="javascript:void(0)" @click="downloadItem(base_url+'ws_cors/download?file='+value.archivo+'&dir=documento_normativo', value.file)"><i class="fa fas fa-download"></i></a>
							<PdfThumbnail :pdfUrl="urlDocumento[k]" :width="120" :height="180" style="height: 200px;"></PdfThumbnail>
							<div class="title">{{ value.titulo || 'REGLAMENTO ELECTORAL' }}</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import PdfThumbnail from '@/components/PdfThumbnail.vue'
export default {
	name: 'DocumentosNormativos',

	components: {
		PdfThumbnail
	},
	computed: {
		...mapState(['empresa']),
		urlDocumento() {
			return this.Documentos.map((item) => {
				this.path_file_download = `${window.baseUrl}ws_cors/download?file=${item.archivo}&dir=documento_normativo`
				console.log(this.path_file_download)
				return this.path_file_download
			})
		}
	},
	data() {
		return {
			Documentos: [],
			path_file_download: '',
			base_url: `${window.baseUrl}`
		}
	},
	mounted() {
		this.getDocumentos()
	},
	methods: {
		...mapMutations(['setLoading']),
		getDocumentos() {
			this.setLoading(true)
			this.$http
				.get('ws_docs_normativos/docs_normatives')
				.then((res) => {
					this.Documentos = res.data.Documentos_normativos
				})
				.finally(() => {
					let _this = this
					setTimeout(() => {
						_this.setLoading(false)
					}, 1500)
				})
		}
	}
}
</script>
